/** @jsx jsx */

import { Fragment as _, useState } from 'react';

import { css, jsx } from '@emotion/core';

import { GettingStartedVideo } from './GettingStartedVideo';
import CC_Phone_Character from 'assets/CC_Phone Character.png';
import addInteractionDefault from 'assets/addInteractionDefault.svg';
import addInteractionHover from 'assets/addInteractionHover.svg';
import playVideoDefault from 'assets/playVideoDefault.svg';
import playVideoHover from 'assets/playVideoHover.svg';
import PlayDefault from 'assets/Play Default.svg';
import PlayHover from 'assets/Play Hover.svg';
import theGwillest from 'assets/the Gwillest.png';
import pubSub from 'services/pubSub';
import { useSelector } from 'react-redux';
import { State } from 'store/store';
import addInteractionBKG from 'assets/addInteractionBKG.svg';
import theresNothingHereYet from 'assets/theresNothingHereYet.png';
import watchAQuickHowToVideo from 'assets/watchAQuickHowToVideo.png';

const Hover = ({ children }) => {
  const [hover, setHover] = useState(false);

  return (
    <div onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)}>
      {children(hover)}
    </div>
  );
};

const DashboardRow = props => {
  const { color = '#000', background = '#fff', children } = props;

  return (
    <div
      css={css({
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        width: '100%',
        padding: 20,
        borderRadius: 20,
        margin: '10px 0',
        color,
        background,
      })}
    >
      {children}
    </div>
  );
};

const Templates = () => {
  return (
    <_>
      <div style={{ margin: '20px 0', fontSize: 18, fontWeight: 500 }}>
        Start with a template
      </div>
      <div style={{ fontSize: 12, fontWeight: 500 }}>
        Click here to access library
      </div>
      <div>
        <button
          css={css({
            all: 'unset',
            width: 200,
            height: 45,
            margin: '25px 0',
            background: '#19D1CF',
            color: '#fff',
            textAlign: 'center',
            borderRadius: 9999,
            cursor: 'pointer',
            transition: 'opacity 0.2s',
            ':hover': {
              opacity: 0.8,
            },
          })}
          onClick={() => {
            pubSub.publish('SHOW_MODULE_TEMPLATES', {
              showModuleTemplates: true,
            });
          }}
        >
          Templates
        </button>
      </div>
    </_>
  );
};

const DashBoard = () => {
  // const [gettingStarted, setGettingStarted] = useState<boolean>(false);

  const paddingX = '10vw';
  const paddingY = '108px';

  return (
    <div
      css={css({
        position: 'fixed',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        left: 0,
        top: 70,
        width: '100vw',
        height: 'calc(100vh - 70px)',
        padding: `${paddingY} ${paddingX}`,
      })}
    >
      <DashboardRow color={'#fff'} background={'#9338FF'}>
        <div
          css={css({
            flex: 1,
            height: `calc(100% + 50px)`,
            background: `url('${CC_Phone_Character}') no-repeat`,
            backgroundSize: 'contain',
            backgroundPosition: 'center bottom',
            transform: 'translate(50px, -50px)',
          })}
        />

        <div
          css={css({
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0 20px',
          })}
        >
          <div>
            <h1
              style={{
                fontSize: 24,
                fontWeight: 500,
                margin: '0 0 15px 0',
                textAlign: 'center',
              }}
            >
              Jump straight into it
            </h1>
            <h2
              style={{
                fontSize: 16,
                fontWeight: 200,
                textAlign: 'center',
              }}
            >
              Start with an interaction
            </h2>
          </div>
        </div>

        <div
          css={css({
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: 12,
          })}
        >
          <Hover>
            {hover => (
              <img
                src={hover ? addInteractionHover : addInteractionDefault}
                style={{
                  width: 60,
                  margin: '0 0 15px 0',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  transform: `scale(${hover ? 1.1 : 1})`,
                  transformOrigin: 'center',
                }}
                onClick={e => {
                  parent.setNewSectionWizard &&
                    parent.setNewSectionWizard(true);
                }}
              />
            )}
          </Hover>
          <div>Add an interaction</div>
        </div>
      </DashboardRow>

      <DashboardRow background={'#F5F6FB'}>
        <div
          css={css({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',

            flex: 1,
          })}
        >
          <Hover>
            {hover => (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'relative',
                }}
              >
                <div
                  style={{
                    position: 'relative',
                  }}
                >
                  <img
                    src={hover ? PlayHover : PlayDefault}
                    css={css({
                      width: 60,
                      height: 60,
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      transform: `scale(${hover ? 1.1 : 1})`,
                      transformOrigin: 'center',
                    })}
                    onClick={e => {
                      pubSub.publish('SHOW_GETTING_STARTED_VIDEO', {
                        showGettingStartedVideo: true,
                      });
                    }}
                  />

                  <img
                    src={theGwillest}
                    style={{
                      position: 'absolute',
                      right: -15,
                      top: -15,
                      width: 30,
                      height: 30,
                      border: '2px solid #fff',
                      borderRadius: '50%',
                      pointerEvents: 'none',
                    }}
                  />
                </div>
              </div>
            )}
          </Hover>
        </div>

        <div
          style={{
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            color: '#000',
            fontSize: 24,
            fontWeight: 500,
            textAlign: 'center',
          }}
        >
          <div>Watch a quick</div>
          <div>“how to” video</div>
        </div>

        <div
          css={css({
            flex: 1,
            height: `calc(100% + 20px)`,
            background: `url('${watchAQuickHowToVideo}') no-repeat`,
            backgroundSize: 'contain',
            backgroundPosition: 'center bottom',
            transform: 'translate(-30px, -20px)',
          })}
        />
      </DashboardRow>
    </div>
  );
};

const EmptySection = () => {
  const moduleHasInteractions = useSelector((state: State) => {
    return Object.values(state.blocks)
      .filter(b => {
        return b?.meta?.subType === 'Interaction';
      })
      .some(i => {
        return i?.children?.length;
      });
  });

  if (window.dev() && !moduleHasInteractions) {
    return <DashBoard />;
  }

  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      {!window.dev() ? (
        <_>
          <div
            style={{
              width: '50%',
              height: '50%',
              background: `url('${theresNothingHereYet}') no-repeat`,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
            }}
          />
          <div
            style={{
              position: 'relative',
              top: '30px',
              textAlign: 'center',
              color: '#0094ff',
              fontWeight: 300,
            }}
          >
            There are no interactions here yet
          </div>
        </_>
      ) : (
        <_>
          <div
            style={{
              position: 'absolute',
              width: '50%',
              height: '50%',
              background: `url('${addInteractionBKG}') no-repeat`,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
            }}
          />
          <button
            style={{
              all: 'unset',
              position: 'relative',
              width: 60,
              height: 60,
            }}
            onClick={e => {
              parent.setNewSectionWizard && parent.setNewSectionWizard(true);
            }}
          >
            <AddInteractionBtn />
          </button>
          <div
            style={{
              position: 'relative',
              top: '15px',
              textAlign: 'center',
              color: '000',
              fontWeight: 500,
            }}
          >
            Add an interaction.
          </div>
        </_>
      )}
    </div>
  );
};

const AddInteractionBtn = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      css={css({
        position: 'relative',
        cursor: 'pointer',
        fill: 'none',
        ':hover': {
          '.actual-btn': {
            fill: '#00D9D3',
          },
        },
      })}
    >
      <rect
        className="actual-btn"
        width="60"
        height="60"
        rx="12"
        css={css({
          fill: '#1D2026',
          transition: 'fill 0.2s',
        })}
      />
      <rect x="28" y="18" width="4" height="24" fill="white" />
      <rect
        x="18"
        y="32"
        width="4"
        height="24"
        transform="rotate(-90 18 32)"
        fill="white"
      />
    </svg>
  );
};

export default EmptySection;
